export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8522.068cb4c2.jpg";